import { browserTracingIntegration, captureConsoleIntegration } from '@sentry/react';
import * as Sentry from '@sentry/react';
import { getEnvironment, isDevelopment, isLocal } from './util/environment';

function initSentry() {
  if (isLocal() || isDevelopment() || !import.meta.env.VITE_SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: getEnvironment(),
    enableLogs: true, // Send all log & warn to sentry
    integrations: [browserTracingIntegration(), captureConsoleIntegration({ levels: ['error'] })],
    release: import.meta.env.VITE_DEPLOY_VERSION,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
  });
}

initSentry();

let appLoadSpan: Sentry.Span | undefined;

export function startAppLoadSpan() {
  if (!appLoadSpan) {
    appLoadSpan = Sentry.startInactiveSpan({ name: 'app.load', op: 'ui.load' });
  }
}

export function endAppLoadSpan() {
  appLoadSpan?.end();
  appLoadSpan = undefined;
}
